import firebase from 'firebase/app'
// const firebase = require('firebase/app');
// import "firebase/analytics";

import 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyDR7pexBAfPubFeiJ1Vx9Gkhu-RgR0_S6k',
  authDomain: 'smallsky.firebaseapp.com',
  projectId: 'smallsky',
  storageBucket: 'smallsky.appspot.com',
  messagingSenderId: '646267924473',
  appId: '1:646267924473:web:a2989878f612f5e08f1728'
}

// Initialize Firebase

firebase.initializeApp(firebaseConfig)

firebase.firestore()

export default firebase
